var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgCaretSort = function SvgCaretSort(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 17 16"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    fillOpacity: 0.01,
    d: "M.6 0h16v16H.6z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#60646C",
    fillRule: "evenodd",
    d: "M5.86 5.794a.48.48 0 0 0 .68.679l2.06-2.06 2.06 2.06a.48.48 0 1 0 .68-.68l-2.4-2.4a.48.48 0 0 0-.68 0zm5.48 4.412a.48.48 0 0 0-.68-.679l-2.06 2.06-2.06-2.06a.48.48 0 0 0-.68.679l2.4 2.4a.48.48 0 0 0 .68 0z",
    clipRule: "evenodd"
  })));
};
export default SvgCaretSort;